import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import AppBarComponent from '../newTestPrepDesign/component/AppBar';

const TermsOfUse = () => {
  const sectionTitleStyle = {
    fontWeight: 'bold',
    color: '#228B22',
    fontSize: "16px"
  };

  return (
    <>
    <Box>
    <AppBarComponent />
    </Box>
    <Container maxWidth="md" sx={{ py: 4, mt: 12 }}>
      <Typography variant="h2" gutterBottom>
       Terms of Use, Privacy Policy, Disclaimer and Refund Policy
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        <strong>Effective Date:</strong> 07/01/2025
      </Typography>
      <Typography gutterBottom>
        <strong>Website:</strong> <a href="https://siectestmasters.com" target="_blank" rel="noopener noreferrer">https://siectestmasters.com</a><br />
        <strong>Company: STM</strong>
      </Typography>

      <Box mt={4}>
        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>Disclaimer</Typography>
        <Typography paragraph>
          By submitting any personal information on this website, including your contact number or email address, you consent to receive calls, SMS, or emails from <strong>STM</strong> regarding your interest in our services or products. These communications shall be considered as solicited, and will not fall under any DND (Do Not Disturb) or Do Not Call restrictions you may have previously enabled. If your contact information was submitted incorrectly or on your behalf by someone else, you may request its deletion by contacting us directly.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>1. Acceptance of Terms</Typography>
        <Typography paragraph>
          By accessing or using <a href="https://siectestmasters.com" target="_blank" rel="noopener noreferrer">https://siectestmasters.com</a>, you agree to be bound by these Terms and Conditions. If you do not agree, you must discontinue using this website.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>2. Privacy Policy</Typography>
        <Typography paragraph><strong>How We Protect Customer Data:</strong> All payment data is transmitted securely through SSL encryption protocols. We do not store your card information directly on our servers.</Typography>
        <Typography paragraph><strong>How We Use Your Data:</strong> We collect only essential personal information such as your name, email, contact number, and address for the purpose of fulfilling services or orders. Your card information is processed securely through our payment partner (e.g., Razorpay or ICICI Bank).</Typography>
        <Typography paragraph><strong>Cookies:</strong> We use cookies to enhance user experience, store preferences, deliver personalized content, and analyze traffic. By continuing to use our site, you agree to the use of cookies.</Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>3. Legal Advice Disclaimer</Typography>
        <Typography paragraph>
          All information on this website is for informational purposes only and does not constitute professional advice. Your use of any content is at your own risk.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>4. Changes to Website or Terms</Typography>
        <Typography paragraph>
         <strong>STM</strong> may modify the site or these terms at any time without prior notice. Continued use of the website implies acceptance of the updated terms.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>5. External Links</Typography>
        <Typography paragraph>
          Our website may contain links to third-party sites. These are provided for convenience only, and <strong>STM</strong> does not take responsibility for content or services provided on external websites.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>6. Intellectual Property</Typography>
        <Typography paragraph>
          All content, including images, text, graphics, and logos, is the property of <strong>STM</strong> and is protected by copyright laws. You may not reuse or reproduce any material without prior written consent.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>7. Linking to Our Site</Typography>
        <Typography paragraph>
          You may link to our homepage, provided you do not imply any endorsement or misrepresent your relationship with us. Sites linking to us must not contain offensive, unlawful, or infringing material.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>8. Limitation of Liability</Typography>
        <Typography paragraph>
          We do not guarantee uninterrupted or error-free service. In no event shall <strong>STM</strong> be liable for indirect damages, loss of data, business interruption, or personal injury resulting from your use of our website or services.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>9. Indemnification</Typography>
        <Typography paragraph>
          You agree to indemnify and hold <strong>STM</strong>, its employees, and agents harmless from all claims, liabilities, and expenses arising from your use or misuse of this website.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>10. Severability</Typography>
        <Typography paragraph>
          If any provision in these terms is found to be invalid by a court of law, the remaining provisions will continue in full force and effect.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>11. Waiver</Typography>
        <Typography paragraph>
          Failure by us to enforce any rights under these terms does not constitute a waiver of those rights.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>12. Governing Law</Typography>
        <Typography paragraph>
          These terms are governed by the laws of India. You agree to submit to the exclusive jurisdiction of the courts in India for any dispute.
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>13. Refund Policy</Typography>
        <Typography paragraph><strong>Applicability:</strong> This policy applies only to purchases made on https://student.siectestmasters.in and excludes any payments made offline or at physical centers.</Typography>
        <Typography paragraph><strong>Conditions for Refund:</strong> Cancellation must be requested before the first set of materials is dispatched. Refund requests must be submitted before the first login or use of the service.</Typography>
        <Typography paragraph>
          <strong>How to Request a Refund:</strong> Send an email from the registered email ID to{' '}
          <a href="mailto:cscanada@siecindia.com"><strong>cscanada@siecindia.com</strong></a> or a signed letter to:{' '}
          <strong>A1/153, Ground Floor, Behind Green Fields School, Safdarjung Enclave, New Delhi 110 029</strong>
        </Typography>

        <Typography paragraph>
          <strong>Refund Processing:</strong> Refunds are subject to deduction of an administrative fee of Rs. 1000/- or 10% of the 
          transaction amount, whichever is higher. <br />
          Refunds for credit card payments will be credited back to the same card. <br />
          For payments via cheque or demand draft, refunds will be issued to the original payee 
          and address. <br />
          No refunds will be processed once material has been dispatched or accessed.
        </Typography>

        <Typography paragraph><strong>Timeline:</strong> Refunds may take 5 working days to process and will be issued within 30 working days thereafter.</Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>Contact Information</Typography>
        <Typography>For any legal, privacy, or refund queries, you may reach us at:</Typography>
        <Typography>
          📧 Email: <a href="mailto:cscanada@siecindia.com">cscanada@siecindia.com</a><br />
          📍 Address: A1/153, Ground Floor, Behind Green Fields School, Safdarjung Enclave, New Delhi 110 029
        </Typography>
      </Box>
    </Container>
    </>
  );
};

export default TermsOfUse;
